import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findPractitionerRoles = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/practitioner-roles${query}`,
    {
      headers,
    },
  );
};

export const findPractitionerRoleById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/practitioner-roles/${id}`,
    {
      headers,
    },
  );
};

export const createPractitionerRole = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_INFO_API_URL}/practitioner-roles`,
    data,
    {
      headers,
    },
  );
};

export const updatePractitionerRole = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_INFO_API_URL}/practitioner-roles/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deletePractitionerRole = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_INFO_API_URL}/practitioner-roles/${id}`,
    {
      headers: headers,
    },
  );
};
